import { APP } from '../enums';
import { injectedStore } from '../globals/StoreAccess';

export const isWeb = () =>
  injectedStore.getState().device.platform === APP.PLATFORM.BROWSER;
